
// Builds a queue that can be used to batch jobs into a rAF
export default function () {
  const callbacks = []

  let requestId = null

  // Adds a job, `fn` to the callbacks
  function queue (fn, ctx) {
    callbacks.push({fn, ctx})

    if (!requestId) {
      requestId = window.requestAnimationFrame(flush)
    }
  }

  // Clears the queue
  queue.clear = function () {
    callbacks.length = 0
    if (requestId) {
      window.cancelAnimationFrame(requestId)
    }
    requestId = null
  }

  // Adds the job, `fn` to the queue, ensuring it's only called once
  queue.once = function (fn, ctx) {
    for (var i = callbacks.length - 1; i >= 0; i--) {
      if (callbacks[i].fn === fn) {
        return
      }
    }
    queue(fn, ctx)
  }

  // Calls `fn` after all jobs in the queue have executed
  queue.defer = function (fn) {
    window.requestAnimationFrame(window.requestAnimationFrame.bind(null, fn))
  }


  // Returns the length of the queue
  queue.size = function () {
    return callbacks.length
  }

  // Runs each job in the list of callbacks
  function flush () {
    while (callbacks.length) {
      let job = callbacks.shift()
      job.fn.call(job.ctx) // Use bound context
    }

    requestId = null
  }

  return queue
}
